// extracted by mini-css-extract-plugin
export default {"container":"input-text_container__lptfg","input":"input-text_input__oWtjC"};